"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var NAME = 'fontfamily';
var whiteList = /(微软雅黑|Microsoft YaHei|Arial|Tahoma|Verdana|宋体|SimSuncss)/i;
function fontFamilySanitize(value) {
    var fontfamily;
    switch (value) {
        case '微软雅黑': {
            fontfamily = 'Microsoft Yahei';
            break;
        }
        case '宋体': {
            fontfamily = 'SimSuncss';
            break;
        }
        default: {
            fontfamily = value;
            break;
        }
    }
    return fontfamily;
}
exports.fontFamilySanitize = fontFamilySanitize;
var FontFamily = /** @class */ (function (_super) {
    __extends(FontFamily, _super);
    function FontFamily() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'font'; };
        _this.attrs = {
            style: {
                default: 'font-family: Microsoft YaHei;'
            }
        };
        _this.parseDOM = [
            {
                tag: 'span',
                getAttrs: getAttrs
            },
            {
                tag: 'font',
                getAttrs: getAttrs
            }
        ];
        return _this;
    }
    return FontFamily;
}(core_utilities_1.Inline));
exports.FontFamily = FontFamily;
function getAttrs(dom) {
    var fontFamily = dom.style.fontFamily;
    var value = fontFamily || '';
    if (whiteList.test(value)) {
        var fontfamily = whiteList.exec(value);
        if (fontfamily) {
            return {
                style: "font-family: " + fontFamilySanitize(fontfamily[1]) + ";"
            };
        }
    }
    return false;
}
exports.getAttrs = getAttrs;
var FontFamilyController = /** @class */ (function (_super) {
    __extends(FontFamilyController, _super);
    function FontFamilyController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'fontfamily',
            tooltip: 'fontfamily',
            type: 'select',
            value: [
                {
                    attrs: { style: 'font-family: Microsoft YaHei;' },
                    text: '微软雅黑'
                },
                {
                    attrs: { style: 'font-family: SimSuncss;' },
                    text: '宋体'
                },
                {
                    attrs: { style: 'font-family: Arial;' },
                    text: 'Arial'
                }
            ]
        };
        return _this;
    }
    return FontFamilyController;
}(core_utilities_1.SylController));
exports.FontFamilyController = FontFamilyController;
var FontFamilyPlugin = /** @class */ (function (_super) {
    __extends(FontFamilyPlugin, _super);
    function FontFamilyPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = FontFamilyController;
        _this.Schema = FontFamily;
        return _this;
    }
    return FontFamilyPlugin;
}(core_utilities_1.SylPlugin));
exports.FontFamilyPlugin = FontFamilyPlugin;
//# sourceMappingURL=font-family.js.map